// extracted by mini-css-extract-plugin
export var layout = "b_b";
export var layoutScrollDisabled = "b_c";